import { render, staticRenderFns } from "./AssignContactsModal.vue?vue&type=template&id=c133338e"
import script from "./AssignContactsModal.vue?vue&type=script&lang=js"
export * from "./AssignContactsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports